// @file Entrypoint for Library Lti app
import { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import { useLibraryLtiStore } from '@@/pinia/library_lti_store'
import LibraryLtiApp from '@@/vuecomponents/LibraryLtiApp.vue'

void setupVueApp({
  el: '#library_lti_app',
  rootComponent: LibraryLtiApp,
  usePinia: true,
  initializePiniaStore() {
    useLibraryLtiStore().initialize(ww.vueStartingState)
  },
})
